

const template = document.createElement('template');
template.innerHTML = `
<style>

  :host {
    display: block;
    width: 100%;
  }
  
  * { 
    box-sizing: border-box; 
  }

  .personalisation-input {
    position: relative;
    width: 100%;
  }

  .input {
    background-color: var(--transparent-navy-navy-4);
    border: none;
    border-radius: 3rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.135rem;
    height: 2.5rem;
    margin-bottom: 1rem;
    max-width: 100%;
    width: 100%;
    padding: 0.5rem 4.5rem 0.5rem 1.25rem;
    text-transform: capitalize;
    font-family: 'Sohne', sans-serif;
  }

  .input::placeholder {
    color: rgba(18, 50, 71, 0.40);
  }

  .input.is-uppercase {
    text-transform: uppercase;
  }

  .text-count {
    position: absolute;
    top: 0.6875rem;
    right: 1.25rem;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.135rem;
    text-transform: uppercase;
    color: rgba(18, 50, 71, 0.40);
  }
  .personalisation-input {
    position: relative;
    width: 100%;
  }
</style>

<div class="personalisation-input" part="navigation">
  <input class="input">
  <div class="text-count"></div>
</div>
`;
export class PersonalisationInput extends HTMLElement {

  private readonly root: HTMLDivElement | null;
  private readonly input: HTMLInputElement;
  private readonly textCount: HTMLDivElement;
  private componentPlaceholder: string = this.getAttribute('placeholder') || "";
  private componentValue: any = this.getAttribute('value') || "";
  private uppercase: boolean = this.hasAttribute('is-uppercase');
  private key: string | null = null;
  private maxCharacters: number = 0;

  constructor() {
    super();
    this.key = this.getAttribute('key');
    if (!this.key) console.error('Need to provide a key which matches one in the personalisationData object', this);

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.personalisation-input')!;
    this.input = shadowRoot.querySelector('.input')!;
    this.textCount = shadowRoot.querySelector('.text-count')!;

    this.input.addEventListener('input', this.handleInput.bind(this));
  }

  connectedCallback() {
    this.input.placeholder = this.componentPlaceholder;
    if(this.componentValue) this.input.value = this.componentValue;
    if (this.uppercase) this.input.classList.add('is-uppercase');
    let currentLength = this.componentValue ? parseInt(this.componentValue.length) : 0;

    this.maxCharacters = parseInt(this.getAttribute('max-characters') || '0');
    this.textCount.textContent = `${currentLength}/${this.maxCharacters}`;
    this.input.setAttribute('maxlength', `${this.maxCharacters}`);
  }

  clearInput() {
    this.input.value = '';
    this.textCount.textContent = `0/${this.maxCharacters}`;
  }
  
  private handleInput(e) {
    const currentLength = (e.target as HTMLInputElement).value.length;
    this.textCount.textContent = `${currentLength}/${this.maxCharacters}`;

    const event = new CustomEvent('data_update', { 
      detail: { 
        data: {
          [this.key as string]: this.input.value, // Spread multiple key-value pairs dynamically
        }
      },
      bubbles: true, 
      composed: true 
    });

    this.dispatchEvent(event);
  }
}

if(!customElements.get('personalisation-input')) {
  customElements.define('personalisation-input', PersonalisationInput);
}